import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { track } from "@/lib/api";

export default function CTASection({
  title = "Ready to take control of your lighting system?",
  sub = "Explore the Amaya Pro ecosystem or talk with our team about your project.",
}) {
  return (
    <section className="relative bg-forest text-white overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 opacity-40 pointer-events-none" aria-hidden="true"
        style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)", backgroundSize: "72px 72px" }} />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[560px] h-[280px] rounded-full bg-leaf/20 blur-[120px] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl leading-[1.05]">
            {title}
          </h2>
          <p className="text-white/65 text-base md:text-lg mt-6 max-w-xl">{sub}</p>
          <div className="flex flex-wrap gap-4 mt-10">
            <Link
              to="/contact?type=demo"
              data-testid="cta-demo-btn"
              onClick={() => track("cta_click", { cta: "request_demo", location: "cta_section" })}
              className="px-7 py-3.5 bg-signal text-white font-medium hover:bg-leaf hover:text-forest transition-colors flex items-center gap-2"
            >
              Request a Demo <ArrowRight size={16} />
            </Link>
            <Link
              to="/contact?type=quote"
              data-testid="cta-quote-btn"
              onClick={() => track("cta_click", { cta: "get_quote", location: "cta_section" })}
              className="px-7 py-3.5 border border-white/30 text-white hover:border-leaf hover:text-leaf transition-colors"
            >
              Get a Quote
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
